<template>
    <component :is="baseComponent"></component>
</template>
<script>
    export default {
        data() {
            return {
                baseComponent: 'Loading'
            }
        },
        mounted() {
            this.chooseComponent(this.$route);
        },
        methods: {
            chooseComponent(route) {
                if (route.meta.hasOwnProperty('auth') || route.meta.auth) {
                    this.baseComponent = 'Auth'
                } else {
                    this.baseComponent = 'Dashboard'
                }
            }
        },
        watch: {
            $route(to) {
                this.chooseComponent(to)
            }
        }
    }
</script>